import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import InputFiles from "react-input-files";
import { toast } from "react-toastify";
import { validateString } from "../Utils/StringUtils";
import "./ImageField.css"; // #region HOOK

/**
 * Représente une sélection d'image (au format JPEG ou PNG)
 * @class
 * @category Fields
 * @param {Fields.ImageField.propTypes} props Les propriétés du composant
 */

function ImageField(props) {
  // Récupération des props
  var deleteColor = props.deleteColor,
      icon = props.icon,
      keepSpaceIcon = props.keepSpaceIcon,
      name = props.name,
      onChange = props.onChange,
      textColor = props.textColor,
      tooltip = props.tooltip,
      value = props.value,
      width = props.width; // Initilisation du state

  var _useState = useState(null),
      imgData = _useState[0],
      setImgData = _useState[1]; // Changement d'image


  var handleChange = function handleChange(files) {
    // Conversion de l'image en base64
    var file = files[0];

    if (file.size > 25 * 1024) {
      toast.info("L'image ne doit pas dépasser les 25ko");
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      setImgData(reader.result);

      if (onChange) {
        onChange(name, reader.result);
      }
    };
  }; // Suppression de l'image


  var handleDeleteImage = function handleDeleteImage() {
    setImgData(null);

    if (onChange) {
      onChange(name, null);
    }
  }; // Cycle de vie


  useEffect(function () {
    // Initialisation de l'image
    setImgData(value);
  }); // Interface

  return /*#__PURE__*/React.createElement("div", {
    className: "ImageField-Container",
    style: {
      width: width
    }
  }, (icon || keepSpaceIcon) && /*#__PURE__*/React.createElement("div", {
    className: "ImageField-IconContainer"
  }, icon && /*#__PURE__*/React.createElement("i", {
    className: "ImageField-Icon fas fa-" + icon,
    style: {
      color: textColor
    },
    "data-tip": tooltip,
    "data-for": "DefaultTooltip"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row"
    }
  }, /*#__PURE__*/React.createElement(InputFiles, {
    children: /*#__PURE__*/React.createElement("button", {
      style: {
        height: "40px",
        width: "100px",
        marginRight: "5px"
      }
    }, "S\xE9lectionner une image"),
    onChange: handleChange,
    multiple: false,
    accept: "image/jpeg, image/png"
  }), /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: imgData,
    style: {
      maxHeight: "150px",
      maxWidth: "200px"
    }
  }), validateString(imgData) && /*#__PURE__*/React.createElement("i", {
    className: "ImageField-IconDelete fas fa-trash-alt",
    style: {
      color: deleteColor
    },
    "data-tip": "Supprimer",
    "data-for": "DefaultTooltip",
    onClick: handleDeleteImage
  })));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link ImageField}
 * @typedef {Object} ImageField.propTypes
 * @property {string} [value=null] Le nom du fichier sélectionné
 * @property {string} name Le nom du champ
 * @property {function} onChange La fonction de callback de l'évènement onChange
 * @property {string} tooltip Le texte du champ
 * @property {string} [textColor=#000] La couleur du texte
 * @property {string} [icon=image] L'icône du champ
 * @property {boolean} [keepSpaceIcon=false] true pour maintenir un écart vide si pas d'icône lorsqu'on empile des champs
 * @property {string} [deleteColor=#000] La couleur de l'icône de suppression
 */


ImageField.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  tooltip: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  icon: PropTypes.string,
  keepSpaceIcon: PropTypes.bool,
  deleteColor: PropTypes.string
} : {};
/*
  Valeurs par défaut des propriétés
*/

ImageField.defaultProps = {
  value: null,
  textColor: "#000",
  icon: "image",
  keepSpaceIcon: false,
  deleteColor: "#000"
}; // #endregion

export { ImageField };